import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import constants from "../../assets/constants.js";
import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import PortalNavDrawer from "../ui/portalNavDrawer";
import BotpressBotStatus from "../widgets/botpressBotStatus";
import BotpressBotUseage from "../widgets/botpressBotUseage";

const BotpressClientPortal = props => {
  return (
    <Portal>
      <PortalAppBar title="Client Portal" botpressStyle={true} />
      <PortalNavDrawer />
      <PortalGridContent hasNavDrawer>
        <Grid size={{ xs: 12, lg: 3 }}>
          <BotpressBotStatus />
        </Grid>

        <Grid size={{ xs: 12, lg: 9 }}>
          <BotpressBotUseage
            botpressGraphType={constants.botpressGraphTypes.overviewGraph}
            colorIndex={4}
          />
        </Grid>

        <Grid size={{ xs: 12, lg: 9 }}>
          <BotpressBotUseage
            botpressGraphType={constants.botpressGraphTypes.usersGraph}
            colorIndex={0}
          />
        </Grid>

        <Grid size={{ xs: 12, lg: 3 }}>
          <BotpressBotUseage
            botpressGraphType={constants.botpressGraphTypes.userTypesGraph}
            colorIndex={0}
          />
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <BotpressBotUseage
            botpressGraphType={constants.botpressGraphTypes.messagesGraph}
            colorIndex={2}
          />
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <BotpressBotUseage
            botpressGraphType={constants.botpressGraphTypes.llmGraph}
            colorIndex={7}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, lg: 4 }} />
      </PortalGridContent>
    </Portal>
  );
};

export default withRouter(BotpressClientPortal);
